import { useIntl } from 'react-intl';
import { useHistory } from 'react-router';
import { Form, Modal, notification } from 'antd';
import { useCreateQuotation } from '@/core/domain/stock/Quotations/Quotations.hooks';
import { ModalProps } from '@/types/ModalProps';
import QuotationForm, { QuotationFormData } from '../QuotationForm';

const CreateQuotationModal = ({ visible, handleVisible }: ModalProps) => {
  const intl = useIntl();
  const history = useHistory();
  const [form] = Form.useForm<QuotationFormData>();

  const mutation = useCreateQuotation();

  const handleOk = async () => {
    try {
      const values = await form.validateFields();

      const result = await mutation.mutateAsync({
        ...values,
        date: values.date.toISOString(),
      });

      notification.success({
        message: intl.formatMessage({
          id: 'quotations.create.notification.success',
        }),
        description: intl.formatMessage({
          id: 'quotations.create.notification.successDescription',
        }),
      });

      handleCancel();

      history.push(`/app/movements/quotations/${result?.result?.id}/items`);
    } catch {}
  };

  const handleCancel = () => {
    form.resetFields();

    handleVisible();
  };

  return (
    <Modal
      title={intl.formatMessage({ id: 'quotations.create' })}
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={mutation.isLoading}
    >
      <QuotationForm form={form} />
    </Modal>
  );
};

export default CreateQuotationModal;
